import {Modal} from "react-bootstrap";
import React, {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {NonComplianceAppealForm} from "./NonComplianceAppealForm";

export function NonComplianceAppealModal({show, setShow, candidatureExternalId, nonCompliance, onSubmitCallback, documents, setDocuments}) {
    const intl = useIntl();
    const [error, setError] = useState(null);
    const [entity, setEntity] = useState(null);

    async function onSubmit() {
        try {
            setShow(false);
            onSubmitCallback?.()
        } catch (error) {
            setError(error);
        }
    }

    function handleClose() {
        setShow(false);
    }

    return (
        <Modal show={show} onHide={handleClose} dialogClassName=''>
            <Modal.Header closeButton>
                <Modal.Title><FormattedMessage id='candidatureTabs.oversight.tabs.noncompliance.appeal' /></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <NonComplianceAppealForm
                    nonCompliance={nonCompliance}
                    documents={documents}
                    setDocuments={setDocuments}
                    candidatureExternalId={candidatureExternalId}
                    onCancel={() => setShow(false)}
                    onSubmitCallback={onSubmit}
                />
            </Modal.Body>
        </Modal>

    );
}